<template>
  <div>

    <vue-qrcode
        :value="qr_code_url"
        :options="
        {
          width: width
        }"
    />

  </div>
</template>


<script>
import VueQrcode from "@chenfengyuan/vue-qrcode";


export default {
  name: 'PlingQrCode',
  components: {VueQrcode},
  props: {
    qr_code_url: {type: String, required: true},
    width: {type: Number, required: false, default: 300},
  },

  data: function () {
    return {}
  }

}
</script>